/* ============================================================
   BSS トップの動き(2026-11 keiju 承認モック「全部盛り」の移植)
   settings.bss_motion_enabled がオンのとき、トップ(index)だけで読み込む。
   既存の Dawn section は書き換えず、ここで見出し等に差し込む。
   ============================================================ */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return [].slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- ステッチ線:本物の糸の縫い目 + 縫い針(モックのまま) ---------- */
  var NS = 'http://www.w3.org/2000/svg', SEQ = 0, STL = [];
  function mk(tag, at, parent) { var e = document.createElementNS(NS, tag); for (var k in at) e.setAttribute(k, at[k]); if (parent) parent.appendChild(e); return e; }
  function rvOf(el) { return el.closest('.bss-mo-rv'); }
  function isIn(el) { var r = rvOf(el); return !r || r.classList.contains('is-in') || root.classList.contains('bss-mo-fallback'); }
  function build(el) {
    var W = Math.round(el.getBoundingClientRect().width) || 120, H = el.clientHeight || 14, Y = H / 2, L = 8, G = 5;
    if (el._w === W) return; el._w = W; el.innerHTML = ''; var id = 'bss-mo-s' + (SEQ++);
    var svg = mk('svg', { 'class': 'sew', 'aria-hidden': 'true', focusable: 'false', viewBox: '0 0 ' + W + ' ' + H }, el);
    var d = mk('defs', {}, svg);
    // 糸の立体感(上が明るく下が暗い)
    var g = mk('linearGradient', { id: id + 'g', x1: 0, y1: 0, x2: 0, y2: 1 }, d);
    [['0', 'color-mix(in srgb,var(--st) 45%,#fff)'], ['.45', 'var(--st)'], ['1', 'color-mix(in srgb,var(--st) 70%,#000)']].forEach(function (t) { mk('stop', { offset: t[0], style: 'stop-color:' + t[1] }, g); });
    // 撚り(斜めの細い線)
    var pt = mk('pattern', { id: id + 't', width: 2.6, height: 4, patternUnits: 'userSpaceOnUse', patternTransform: 'skewX(-38)' }, d);
    mk('rect', { x: 0, y: 0, width: .8, height: 4, fill: 'rgba(0,0,0,.22)' }, pt);
    // 針の金属
    var ng = mk('linearGradient', { id: id + 'n', x1: 0, y1: 0, x2: 1, y2: 0 }, d);
    [['0', '#8d9298'], ['.45', '#f4f6f8'], ['1', '#6c7177']].forEach(function (t) { mk('stop', { offset: t[0], 'stop-color': t[1] }, ng); });
    // 布の下に隠れる部分を切る
    var cp = mk('clipPath', { id: id + 'c' }, d); mk('rect', { x: -12, y: -200, width: W + 24, height: 200 + Y + .4 }, cp); // 左右の余白は小さく(全幅のときに画面端をまたがない)
    var n = Math.max(3, Math.floor((W - 2 + G) / (L + G))), off = (W - (n * L + (n - 1) * G)) / 2, sts = [];
    for (var i = 0; i < n; i++) {
      var x = off + i * (L + G), gr = mk('g', { opacity: 0 }, svg);
      var r0 = mk('rect', { 'class': 'sh', x: x, y: Y - .6, width: L, height: 3.4, rx: 1.7 }, gr);
      var r1 = mk('rect', { x: x, y: Y - 1.7, width: L, height: 3.4, rx: 1.7, fill: 'url(#' + id + 'g)' }, gr);
      var r2 = mk('rect', { x: x, y: Y - 1.7, width: L, height: 3.4, rx: 1.7, fill: 'url(#' + id + 't)' }, gr);
      var h1 = mk('circle', { 'class': 'hole', cx: x - .2, cy: Y, r: .9, opacity: 0 }, gr), h2 = mk('circle', { 'class': 'hole', cx: x + L + .2, cy: Y, r: .9, opacity: 0 }, gr);
      sts.push({ x: x, g: gr, r: [r0, r1, r2], h: [h1, h2] });
    }
    var trail = mk('line', { 'class': 'trail', x1: 0, y1: Y, x2: 0, y2: Y, stroke: 'var(--st)', 'stroke-width': 1.3, 'stroke-linecap': 'round' }, svg);
    // 針(先が下)。目に糸を通して上へ逃がす
    var ndl = mk('g', { 'class': 'ndl', 'clip-path': 'url(#' + id + 'c)' }, svg), nin = mk('g', {}, ndl);
    mk('path', { d: 'M0 -60 Q-3 -44 -1.2 -27', fill: 'none', stroke: 'var(--st)', 'stroke-width': 1.3 }, nin);
    mk('path', { d: 'M0 0 L-1.25 -6 L-1.25 -30 Q0 -32 1.25 -30 L1.25 -6 Z', fill: 'url(#' + id + 'n)', stroke: 'rgba(0,0,0,.25)', 'stroke-width': .3 }, nin);
    mk('ellipse', { cx: 0, cy: -26, rx: .45, ry: 2, fill: '#fff' }, nin);
    el._s = { sts: sts, L: L, G: G, Y: Y, ndl: ndl, nin: nin, trail: trail };
    showAll(el, isIn(el));
  }
  function setStitch(s, w, solid) { s.g.setAttribute('opacity', w > 0 ? 1 : 0); s.r.forEach(function (r) { r.setAttribute('width', Math.max(0, w)); }); s.h.forEach(function (h) { h.setAttribute('opacity', solid ? 1 : 0); }); }
  function showAll(el, on) { var S = el._s; if (!S) return; S.sts.forEach(function (s) { setStitch(s, on ? S.L : 0, on); }); el.classList.remove('sewing'); if (on) el.classList.add('done'); else el.classList.remove('done'); }
  function sew(el) {
    var S = el._s; if (!S || el._raf || el._sewn) return;
    el._sewn = true;
    if (reduce || root.classList.contains('bss-mo-fallback')) { showAll(el, true); return; }
    showAll(el, false); el.classList.add('sewing'); el.classList.remove('done');
    var n = S.sts.length, T = Math.max(34, Math.min(150, 2600 / n)), t0 = null, Y = S.Y, L = S.L, G = S.G, UP = -7, DN = 5;
    function pos(x, y, tilt) { S.ndl.setAttribute('transform', 'translate(' + x.toFixed(2) + ' ' + (Y + y).toFixed(2) + ')'); S.nin.setAttribute('transform', 'rotate(' + tilt + ')'); }
    function frame(ts) {
      if (t0 === null) t0 = ts; var t = (ts - t0) / T, k = Math.floor(t), p = t - k;
      if (k >= n) { S.sts.forEach(function (s) { setStitch(s, L, true); }); pos(S.sts[n - 1].x + L, UP * 2, 0); S.trail.setAttribute('x2', S.trail.getAttribute('x1')); el.classList.add('done'); el._raf = 0; setTimeout(function () { el.classList.remove('sewing'); }, 400); return; }
      for (var i = 0; i < k; i++) setStitch(S.sts[i], L, true);
      var s = S.sts[k], x0 = s.x, x1 = s.x + L, x, y, w = 0, tr = false;
      if (p < .22) { x = x0; y = DN + (UP - DN) * (p / .22); }                                   // 針が布から出る
      else if (p < .62) { var q = (p - .22) / .4; x = x0 + L * q; y = UP - 2 * Math.sin(Math.PI * q); w = L * q; tr = true; } // 糸を引きながら進む
      else if (p < .82) { x = x1; y = UP + (DN - UP) * ((p - .62) / .2); w = L; tr = y < 0; }     // 布に刺さる
      else { x = x1 + G * ((p - .82) / .18); y = DN; w = L; }                                     // 布の下で次の目へ
      setStitch(s, w, p >= .82);
      S.trail.setAttribute('x1', x0 + w); S.trail.setAttribute('y1', Y); S.trail.setAttribute('x2', tr ? x : x0 + w); S.trail.setAttribute('y2', tr ? Y + Math.min(y, 0) + 1 : Y);
      pos(x, y, p < .62 && p >= .22 ? -14 : -6);
      el._raf = requestAnimationFrame(frame);
    }
    el._raf = requestAnimationFrame(frame);
  }
  function sewIn(target) { $$('.bss-mo-stl', target).forEach(function (el) { setTimeout(function () { sew(el); }, el.classList.contains('bss-mo-stl--full') ? 150 : 380); }); }
  function addStitch(parent, opts) {
    var el = document.createElement('i');
    el.className = 'bss-mo-stl' + (opts && opts.cls ? ' ' + opts.cls : '');
    el.setAttribute('aria-hidden', 'true');
    parent.appendChild(el); STL.push(el); return el;
  }

  /* ---------- 見出し:せり上がり + マーカー + ステッチ線 ---------- */
  function decorateHeading(h, marker) {
    if (!h || h.classList.contains('bss-mo-head')) return;
    var mask = document.createElement('span'); mask.className = 'bss-mo-mask';
    var rise = document.createElement('span'); rise.className = 'bss-mo-rise';
    var inner = rise;
    if (marker) { var u = document.createElement('span'); u.className = 'bss-mo-u'; rise.appendChild(u); inner = u; h.classList.add('bss-mo-marked'); }
    while (h.firstChild) inner.appendChild(h.firstChild);
    mask.appendChild(rise); h.appendChild(mask);
    h.classList.add('bss-mo-head');
    var center = getComputedStyle(h).textAlign === 'center';
    addStitch(h, { cls: center ? 'bss-mo-stl--center' : '' });
  }
  function fadeUp(list) { list.forEach(function (el, i) { el.classList.add('bss-mo-fu'); if (i) el.classList.add('bss-mo-d' + Math.min(3, i)); }); }

  function init() {
    var main = $('#MainContent') || document.body;
    var sections = $$('.shopify-section', main);
    var heroSec = null;
    sections.forEach(function (s) { if (!heroSec && $('slideshow-component', s)) heroSec = s; });
    var tpl = $('#bss-motion-hero-tpl');

    /* ヒーロー: 写真カード・リング・英字の小見出し・ボタンの光 */
    if (heroSec) {
      var host = $('slideshow-component', heroSec);
      host.classList.add('bss-mo-hero-host');
      if (tpl && tpl.content) {
        var fl = tpl.content.querySelector('.bss-mo-floater');
        if (fl) host.appendChild(fl.cloneNode(true));
      }
      var slide1 = $('.slideshow__slide', heroSec);
      var box = slide1 && $('.slideshow__text', slide1);
      var kickerText = tpl && tpl.getAttribute('data-kicker');
      if (box && kickerText) {
        box.classList.add('bss-mo-hero-host');
        var k = document.createElement('p'); k.className = 'bss-mo-kicker'; k.setAttribute('aria-hidden', 'true');
        var kt = document.createElement('span'); kt.textContent = kickerText; k.appendChild(kt);
        var caret = document.createElement('span'); caret.className = 'bss-mo-caret'; k.appendChild(caret);
        box.insertBefore(k, box.firstChild);
        if (!reduce) {
          var i = 0; kt.textContent = '';
          var timer = setInterval(function () { i++; kt.textContent = kickerText.slice(0, i); if (i >= kickerText.length) clearInterval(timer); }, 70);
        }
      }
      var b1 = slide1 && $('.button--primary', slide1);
      if (b1) addShine(b1);
    }

    /* シール(持ち込み欄の写真の角) */
    if (tpl && tpl.content) {
      var st = tpl.content.querySelector('.bss-mo-sticker');
      var sid = tpl.getAttribute('data-sticker-section');
      var tgt = sid && $('[id$="__' + sid + '"] .image-with-text__media-item');
      if (st && tgt) { tgt.classList.add('bss-mo-sticker-host'); tgt.appendChild(st.cloneNode(true)); }
      // 持ち込み欄の主ボタンにも光
      var b2 = sid && $('[id$="__' + sid + '"] .button--primary');
      if (b2) addShine(b2);
    }

    /* 各欄: 画面に入ったら見出しがせり上がる・本文 fadeUp・ステッチ */
    sections.forEach(function (s) {
      if (s === heroSec) return;
      var did = false;
      $$('h2.image-with-text__heading', s).forEach(function (h) { decorateHeading(h, true); did = true; });
      $$('h2.banner__heading', s).forEach(function (h) { decorateHeading(h, false); did = true; });
      $$('.bss-works-marquee__heading', s).forEach(function (h) { decorateHeading(h, true); did = true; });
      var iwt = $('.image-with-text', s);
      if (iwt) {
        var media = $('.image-with-text__media-item', s); if (media) media.classList.add('bss-mo-fu');
        fadeUp($$('.image-with-text__content > *:not(.image-with-text__heading)', s));
      }
      var bbox = $('.banner__box', s);
      if (bbox && !iwt) fadeUp($$(':scope > *:not(.banner__heading)', bbox));
      var fus = $$('[data-bss-fu]', s); if (fus.length) fadeUp(fus);
      if (did || fus.length || $('.bss-mo-sticker', s)) s.classList.add('bss-mo-rv');
    });

    /* フッター上端の全幅ステッチ */
    var footer = $('.footer');
    if (footer) {
      var fsec = footer.closest('.shopify-section') || footer;
      var wrap = document.createElement('div'); wrap.className = 'bss-mo-footer-stitch'; wrap.setAttribute('aria-hidden', 'true');
      addStitch(wrap, { cls: 'bss-mo-stl--full' });
      footer.classList.add('bss-mo-footer-host');
      footer.insertBefore(wrap, footer.firstChild);
      fsec.classList.add('bss-mo-rv');
    }

    /* LINE アイコン */
    $$('a[href*="line.me"] svg, a[href*="lin.ee"] svg').forEach(function (svg) { svg.classList.add('bss-mo-ring'); });

    /* 画面に入ったら .is-in(最初から画面内の欄は動かさずに見せる) */
    var rvs = $$('.bss-mo-rv');
    var vh = window.innerHeight || 800;
    var pending = [];
    rvs.forEach(function (e) {
      var r = e.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) e.classList.add('is-in', 'bss-mo-now'); else pending.push(e);
    });
    STL.forEach(build);
    rvs.forEach(function (e) { if (e.classList.contains('is-in')) sewIn(e); });
    if (reduce || !hasIO) {
      pending.forEach(function (e) { e.classList.add('is-in'); sewIn(e); });
    } else {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); sewIn(en.target); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
      pending.forEach(function (e) { io.observe(e); });
    }

    /* 帯・ヒーローは画面内のときだけ動かす */
    var runners = $$('.bss-mo-band, .bss-mo-hero-host');
    if (hasIO) {
      var io2 = new IntersectionObserver(function (es) { es.forEach(function (en) { en.target.classList.toggle('bss-mo-run', en.isIntersecting); }); });
      runners.forEach(function (e) { io2.observe(e); });
    } else runners.forEach(function (e) { e.classList.add('bss-mo-run'); });

    var rzT, lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return; lastW = window.innerWidth; // iOS のアドレスバー伸縮では作り直さない
      clearTimeout(rzT);
      rzT = setTimeout(function () { STL.forEach(function (el) { if (el._raf) return; el._w = 0; build(el); if (el._sewn) showAll(el, true); }); }, 200);
    });
  }

  function addShine(btn) {
    if (btn.querySelector('.bss-mo-shine')) return;
    var s = document.createElement('span'); s.className = 'bss-mo-shine'; s.setAttribute('aria-hidden', 'true');
    btn.appendChild(s);
  }

  function start() {
    try { init(); window.__bssMotionReady = true; }
    catch (e) { root.classList.add('bss-mo-fallback'); window.__bssMotionReady = true; if (window.console) console.warn('bss-motion', e); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
